<h2 mat-dialog-title>
  {{ 'account.dialogs.mfa.setup.title' | t }} <span *ngIf="mfa?.name">({{ mfa.name }})</span>
</h2>
<mat-dialog-content class="mat-typography">
  <sn-alert
    dense
    class="alert-rounded"
    type="danger"
    *ngIf="passwordForm.errors || codeForm.errors"
  >
    <div *ngFor="let error of passwordForm.errors | keyvalue">
      <b>{{ toStartCase(error.key) }}</b
      >:
      <ng-container *ngIf="isArray(error.value); else singlePasswordError">
        <ul class="error-list">
          <li *ngFor="let item of error.value">{{ item }}</li>
        </ul>
      </ng-container>
      <ng-template #singlePasswordError>
        <ul class="error-list">
          <li>{{ error.value }}</li>
        </ul>
      </ng-template>
    </div>
    <div *ngFor="let error of codeForm.errors | keyvalue">
      <b>{{ toStartCase(error.key) }}</b
      >:
      <ng-container *ngIf="isArray(error.value); else singleCodeError">
        <ul class="error-list">
          <li *ngFor="let item of error.value">{{ item }}</li>
        </ul>
      </ng-container>
      <ng-template #singleCodeError>
        <ul class="error-list">
          <li>{{ error.value }}</li>
        </ul>
      </ng-template>
    </div>
  </sn-alert>
  <mat-stepper linear>
    <mat-step [stepControl]="passwordForm">
      <h4>{{ 'account.dialogs.mfa.setup.confirmStep' | t }}</h4>
      <sn-form [form]="passwordForm" [fields]="passwordFields" [(model)]="formModel"></sn-form>
      <div class="stepperNav">
        <button mat-button color="warn" mat-dialog-close>{{ 'common.cancel' | t }}</button>
        <button
          mat-flat-button
          style="width: 50%"
          [mtBasicSpinner]="isLoading"
          [hideText]="true"
          [disabled]="passwordForm.invalid"
          color="success"
          (click)="createMfa()"
        >
        {{ 'common.next' | t }}
        </button>
      </div>
    </mat-step>
    <mat-step>
      <div class="backupCodes">
        <div class="subTitleHeader">
          <h2>{{ 'common.backupCodes' | t }}</h2>
        </div>
        <section>
          <p>
            {{ 'account.dialogs.mfa.backupCodes.description' | t }}<br />
            {{ 'account.dialogs.mfa.backupCodes.securityMessage' | t }}
          </p>
        </section>

        <sn-alert dense class="alert-rounded" type="dark">
          <sn-icon fontSet="fal" fontIcon="fa-circle-info"></sn-icon> {{ 'account.dialogs.mfa.backupCodes.securityWarning' | t }}
        </sn-alert>

        <section *ngIf="backupCodes?.tokens?.length">
          <div class="token-container tokenWrapper">
            <div class="token-grid printContent">
              <div class="token-item" *ngFor="let token of backupCodes.tokens">
                {{ token }}
              </div>
            </div>
            <div class="token-actions-wrapper">
              <div class="tokenActions">
                <button mat-button color="accent" (click)="print()">
                  <sn-icon fontSet="fal" fontIcon="fa-print"></sn-icon>
                  {{ 'common.print' | t }}
                </button>
                <button mat-button [cdkCopyToClipboard]="copyContent" color="accent">
                  <sn-icon fontSet="fal" fontIcon="fa-copy"></sn-icon>
                  {{ 'common.copy' | t }}
                </button>
              </div>
            </div>
          </div>
        </section>
        <section style="margin-top: 1rem">
          <h3>
            {{ 'account.dialogs.mfa.backupCodes.securityNote' | t }}
          </h3>
        </section>
        <div class="stepperNav">
          <button mat-button color="warn" (click)="cancel()">{{ 'common.cancel' | t }}</button>
          <button mat-flat-button style="width: 50%" color="success" (click)="next()">{{ 'common.next' | t }}</button>
        </div>
      </div>
    </mat-step>
    <mat-step [stepControl]="codeForm">
      <div class="subTitleHeader">
        <h2>{{ 'account.dialogs.mfa.manage.setupTitle' | t }}</h2>
      </div>
      <mat-divider></mat-divider>
      <h3>{{ 'account.dialogs.mfa.manage.scanInstructions' | t }}</h3>
      <qrcode
        *ngIf="qrCodeUrl"
        colorLight="#141217"
        colorDark="#FFCA28"
        [qrdata]="qrCodeUrl"
        [width]="256"
        [errorCorrectionLevel]="'M'"
      ></qrcode>
      <br />
      <h3>
        {{ 'account.dialogs.mfa.manage.codeInstructions' | t }}
      </h3>
      <sn-form [form]="codeForm" [fields]="codeField" [(model)]="formModel"></sn-form>
      <div class="stepperNav">
        <button color="warn" mat-button (click)="cancel()">{{ 'common.cancel' | t }}</button>
        <button mat-button (click)="previous()">{{ 'common.back' | t }}</button>
        <button
          mat-button
          [mtBasicSpinner]="isLoading"
          [hideText]="true"
          [disabled]="codeForm.invalid"
          color="success"
          (click)="verifyAppCode()"
        >
          {{ 'common.finish' | t }}
        </button>
      </div>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
